import Demo1 from './demo-01';
import Demo2 from './demo-02';

export default {
    Demo1,
    Demo2,
}